import translation from "./translations.json";

const images = {
  AUTH_LOGO: require("./assets/images/authLogo.png"),
  AUTH_BACKGROUND: require("./assets/images/background.png"),
  SIDEBAR_LOGO: require("./assets/images/sidebar.png"),
  BG_1: require("./assets/bg/bg1.png"),
  BG_2: require("./assets/bg/bg2.png"),
  BG_3: require("./assets/bg/bg3.png"),
  BG_4: require("./assets/bg/bg4.png"),
  BG_5: require("./assets/bg/bg5.png"),
  BG_6: require("./assets/bg/bg6.png"),
};

const lightColors = {
  "--color-primary": "#00355f",
  "--color-secondary": "#66869f",
  "--color-tertiary": "#5094e2",
  "--color-white": "#ffffff",
  "--background-50": "#00355f",
  "--background-100": "#4a90e2",
  "--background-200": "#a7a9ac",
  "--background-300": "#335d7f",
  "--background-400": "#66869f",
  "--background-500": "#b9babd",
  "--background-600": "#a7a9ac",
  "--background-700": "#ddddde",
  "--background-800": "#f2f2f2",
  "--background-900": "#ffffff",
  "--background-950": "#00355f",
};

const darkColors = {
  "--color-primary": "#4a90e2",
  "--color-secondary": "#a7a9ac",
  "--color-tertiary": "#5094e2",
  "--color-white": "#ffffff",
  "--background-50": "#00355f",
  "--background-100": "#4a90e2",
  "--background-200": "#a7a9ac",
  "--background-300": "#335d7f",
  "--background-400": "#66869f",
  "--background-500": "#b9babd",
  "--background-600": "#a7a9ac",
  "--background-700": "#ddddde",
  "--background-800": "#f2f2f2",
  "--background-900": "#ffffff",
  "--background-950": "#00355f",
};

const colors = {
  light: lightColors,
  dark: darkColors,
};

const translations = translation;

const links = {
  support: "https://www.atomservices.io/contact#SUPPORT",
  contact: "https://www.atomservices.io/contact",
  privacyPolicy: "https://www.atomservices.io/privacy-policy",
  terms: "https://www.atomservices.io/terms-and-conditions",
};

const platform = 'precisionsmartmetering';

export const precisionsmartmetering = {
  images,
  colors,
  translations,
  links,
  platform,
  availableReports: [1, 2, 3, 4, 5, 6, 7, 8], // All reports available, adjust as needed
};
